module.exports = __webpack_public_path__ + "static/media/R-smart-classic-c.6bcd9758.jpg";